export default "__VITE_ASSET__oafc5H8Q__";